<script>

import TextareaTemplates from "@/components/TextareaTemplates.vue";
import { uuid } from 'vue-uuid';

export default {
  components: {TextareaTemplates},
  props: {
    drupalInputId: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      loading: false,
      values: [],
      items: [],
      templatesDialog: false,
      inputId: 'multiple-ac-' + uuid.v4(),
    }
  },
  watch: {
    values: {
      handler(newValue, oldValue) {
        const element = this.drupalInputElement();
        // Convert to JSON
        // Set value in the Drupal DOM input element
        element.value = JSON.stringify(this.values);
      },
      deep: true
    },
  },
  async mounted() {
    // Check if drupal_input_id already has a value
    const element = this.drupalInputElement();
    console.log(element.value)
    if (element.value) {
      // Restore the values
      this.values = JSON.parse(element.value);
    }
  },
  methods: {
    drupalInputElement() {
      // Get the Drupal DOM input element
      const element_id = "#"+this.drupalInputId;
      const element = document.querySelector(element_id);
      return element;
    },
    async search(event) {
      this.items = await this.getAutocompleteResults(event.query)
    },
    /**
     * @returns {Promise<void>}
     */
    async getAutocompleteResults(query) {
      this.loading = true;
      // Get the agendas
      let params = {
        query: query,
      };
      const response = await fetch('/api/email/autocomplete/email-addresses?' + new URLSearchParams(params), {
        credentials: "include"
      })
      this.loading = false;
      const status_code = response.status;
      if (status_code !== 200) {
        // Show toast
        this.$toast.add({ severity: 'error', summary: 'Fout', detail: 'Kon de autocomplete resultaten niet laden.' });
      }
      // Parse the response
      return await response.json();
    },
    handleAddNewEmail(event) {
      const value = event.srcElement.value;
      // Don't create empty objects
      if (!value) {
        return;
      }
      // Explode the value on comma
      const values = value.split(',');
      // Loop over the values
      for (let i = 0; i < values.length; i++) {
        // Add email address
        this.addEmailAddress(values[i]);
      }
      // Remove the value from the input
      event.srcElement.value = '';
    },
    handleBlur(event) {
      // Add the value, just like on enter. But do it with a delay.
      // We need this because otherwise, the user will also add the value when he clicks a value in the suggestion list.
      setTimeout(() => this.handleAddNewEmail(event), 100);
    },
    openTemplatesDialog() {
      this.templatesDialog = true;
    },
    closeTemplatesDialog() {
      this.templatesDialog = false;
    },
    templateSelected(template) {
      // Explode the template.template_text on comma and newlines and add the email addresses
      const values = template.template_text.split(/[\s,]+/);
      // Loop over the values
      for (let i = 0; i < values.length; i++) {
        // Add email address
        this.addEmailAddress(values[i]);
      }
      // Close the dialog
      this.closeTemplatesDialog();
    },
    addEmailAddress(email) {
      const email_trimmed = email.trim();
      // Don't create empty objects
      if (!email_trimmed) {
        return;
      }
      // Create new object
      const newItem = {
        from_name: email_trimmed,
        email: email_trimmed,
      };
      // Add the value to the list
      this.values.push(newItem);
    },
    /**
     * For some unknown reason, the autocomplete input field is not focused when the user clicks on it. Create our own handler for this.
     */
    handleOwnClick() {
      // Find the input element with inputId in the DOM and focus on it
      const element = document.querySelector('#'+this.inputId);
      if (element) {
        element.focus();
      }
    }
  },
}
</script>


<template>

  <div class="d-xl-flex flex-auto">

    <div class="flex flex-auto flex-col">
      <div style="height: 8px">
        <ProgressBar v-if="loading" mode="indeterminate" style="height: 8px"></ProgressBar>
      </div>
      <div @click="handleOwnClick">
        <AutoComplete
          v-model="values"
          :inputId="inputId"
          @keydown.enter.prevent="handleAddNewEmail"
          @blur="handleBlur"
          multiple
          fluid
          optionLabel="from_name"
          :suggestions="items"
          :loading="loading"
          emptySearchMessage="Geen resultaten gevonden"
          @complete="search" />
      </div>

    </div>

    <div class="flex items-center flex-shrink-0" style="width: 175px;">
      <Button label="Sjabloon invoegen" size="small" text @click="openTemplatesDialog">
        <template #icon><i class="far fa-file-alt"></i></template>
      </Button>
    </div>

  </div>


  <!-- Templates dialog -->
  <Dialog v-model:visible="templatesDialog" modal maximizable header="Kies een sjabloon" :style="{ width: '60rem' }">
    <TextareaTemplates @template-selected="templateSelected"></TextareaTemplates>
  </Dialog>


</template>

<style lang="scss">
.p-autocomplete {
  input {
    box-shadow: none !important;
  }
}
</style>
